import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3b180b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-wallet"]

import { computed } from 'vue';
import { getAddress } from '@ethersproject/address';


export default /*#__PURE__*/_defineComponent({
  __name: 'Seller',
  props: { address: {
  type: String,
  required: true,
} },
  setup(__props) {

const props = __props;



const sellerChecksumAddress = computed(() => {
  if (!props.address) {
    return '';
  }
  return getAddress(props.address);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "listing-detail-info-identity",
    "data-widget": "m-wallet-identity",
    "data-wallet": _unref(sellerChecksumAddress),
    class: "manifold-scheme-dark"
  }, null, 8, _hoisted_1))
}
}

})